import { useReveal } from "@/lib/reveal";
import Header from "@/components/fynix/Header";
import Hero from "@/components/fynix/Hero";
import PainPoints from "@/components/fynix/PainPoints";
import AssessmentPillars from "@/components/fynix/AssessmentPillars";
import HowItWorks from "@/components/fynix/HowItWorks";
import WhoItsFor from "@/components/fynix/WhoItsFor";
import Deliverables from "@/components/fynix/Deliverables";
import TrustSection from "@/components/fynix/TrustSection";
import SampleOutcomes from "@/components/fynix/SampleOutcomes";
import SampleScorecard from "@/components/fynix/SampleScorecard";
import FAQ from "@/components/fynix/FAQ";
import BookingForm from "@/components/fynix/BookingForm";
import Footer from "@/components/fynix/Footer";

export default function FynixLanding() {
  useReveal();
  return (
    <div className="min-h-screen bg-[#FAFAFA] text-zinc-950" data-testid="fynix-landing">
      <Header />
      <main>
        <Hero />
        <PainPoints />
        <AssessmentPillars />
        <HowItWorks />
        <WhoItsFor />
        <Deliverables />
        <TrustSection />
        <SampleOutcomes />
        <SampleScorecard />
        <FAQ />
        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}
